import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  SelectedBranchService,
  SelectedWorkspaceService,
} from '@tokenbox/services';
import { BrandLogoComponent } from '@tokenbox/components';

@Component({
  selector: 'dt-sidebar-brand-logo',
  templateUrl: './sidebar-brand-logo.component.html',
  styleUrls: ['./sidebar-brand-logo.component.scss'],
  imports: [RouterLink, BrandLogoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarBrandLogoComponent {
  private selectedWorkspaceService = inject(SelectedWorkspaceService);
  private selectedBranchService = inject(SelectedBranchService);

  protected url = computed(() => {
    const workspace = this.selectedWorkspaceService.selectedWorkspace();
    const branch = this.selectedBranchService.selectedBranch();
    if (workspace && branch) {
      return ['/', 'workspaces', workspace.id, 'branches', branch.id];
    }
    return ['/'];
  });
}
